export const global = {
	editorComponentChangeHandler: 'data-change-handler',
}
